import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const COOKIE_CONSENT_KEY = "cookie-consent";

export const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            // Kurze Verzögerung für sanftere UX
            const timer = setTimeout(() => setVisible(true), 800);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 animate-in slide-in-from-bottom duration-500">
            <div className="max-w-3xl mx-auto bg-card border border-border rounded-lg shadow-2xl shadow-black/40 p-5 sm:p-6">
                <div className="flex items-start gap-4">
                    {/* Icon */}
                    <div className="hidden sm:flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 shrink-0 mt-0.5">
                        <Cookie className="w-5 h-5 text-primary" />
                    </div>

                    {/* Content */}
                    <div className="flex-1 min-w-0">
                        <h3 className="font-serif text-base font-semibold text-foreground mb-2">
                            Cookie-Hinweis
                        </h3>
                        <p className="font-sans text-sm text-muted-foreground leading-relaxed mb-4">
                            Wir verwenden ausschließlich technisch notwendige Cookies, um die
                            Grundfunktionen unserer Website sicherzustellen. Es werden keine
                            Tracking- oder Marketing-Cookies eingesetzt. Weitere Informationen
                            finden Sie in unserer{" "}
                            <Link
                                to="/datenschutz"
                                className="text-primary hover:underline"
                            >
                                Datenschutzerklärung
                            </Link>
                            .
                        </p>

                        {/* Buttons */}
                        <div className="flex flex-col sm:flex-row gap-3">
                            <Button
                                onClick={handleAccept}
                                size="sm"
                                className="font-sans text-xs tracking-wide uppercase"
                            >
                                Verstanden
                            </Button>
                            <Button
                                onClick={handleDecline}
                                variant="outline"
                                size="sm"
                                className="font-sans text-xs tracking-wide uppercase"
                            >
                                Nur notwendige
                            </Button>
                        </div>
                    </div>

                    {/* Close */}
                    <button
                        onClick={handleDecline}
                        className="text-muted-foreground hover:text-foreground transition-colors shrink-0 p-1"
                        aria-label="Cookie-Hinweis schließen"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
